pageId = 'page-join-approval'
page = "##{ pageId }"

$ ->
  $(document)
  .on 'click', "#{ page } .select-all", selectAll
  .on 'click', "#{ page } .td-chb input", selectApproval
  .on 'click', "#{ page } .btn-batch-approval", batchApproval
  .on 'ajax:beforeSend', "#{ page } .btn-batch-reject", beforeBatchReject
  .on 'ajax:success', "#{ page } .btn-batch-reject", batchReject
  .on 'ajax:complete', "#{ page } .btn-batch-reject", completeBatchReject

  $('body')
  .on 'click', "#{ page } .btn-batch-reject", clickBatchReject

$(document)
  .on 'pjaxload#' + pageId ,->
    removeNotification()




selectAll = (e) ->
  chb = $(@)
  chbs = $('.td-chb input:not(:disabled)')
  chbs.prop 'checked', chb.is(':checked')

selectApproval = (e) ->
  chb = $(@)
  unless chb.is(':checked')
    $('.select-all').prop('checked', false)

batchApproval = (e) ->
  e.preventDefault()

  link = $(@)
  return false if link.is('.disabled')

  url = simple.url link.attr('href')
  chbs = $('.td-chb input:checked').map (idx, chb) ->
    return chb.value
  ids = chbs.get()

  unless ids.length
    simple.dialog.message
      content: "你还没有选择任何申请，无法进行此操作。"
    return false

  url.search.ids = ids.join(',')

  tower.stack.load url.toString('relative')

beforeBatchReject = (e, xhr, settings) ->
  link = $(@)

  chbs = $('.td-chb input:checked').map (idx, chb) ->
    return "guids[]=#{ $(chb).data('guid') }"
  guids = chbs.get()

  return false unless guids.length
  settings.data += "&#{ guids.join('&') }"

  $('.btn-batch-reject, .btn-batch-approval').addClass('disabled')

batchReject = (e, result) ->
  return unless result.success

  if $('.jr').length == result.guids.length
    tower.stack.load simple.url().toString('relative'),
      replace: true
  else
    for guid in result.guids
      $(".td-chb input[data-guid=#{ guid }]")
        .closest('tr')
        .remove()

# 之所以要增加这一步，是为了做没有选择的判断，如果在ajax:beforeSend中去判断
# 询问确定拒绝的confirm会先执行，因为要帮到 body 上，如果没有选择任何申请就
# 组织事件冒泡
clickBatchReject = (e) ->
  chbs = $('.td-chb input:checked').map (idx, chb) ->
    return "guids[]=#{ $(chb).data('guid') }"
  guids = chbs.get()

  unless guids.length
    simple.dialog.message
      content: "你还没有选择任何申请，无法进行此操作。"
    return false

completeBatchReject = (e) ->
  $('.btn-batch-reject, .btn-batch-approval').removeClass('disabled')

removeNotification = ->
  $('.system-message.join-request').remove()

